import { IDynamicSimpleText } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { SingleProductDataType } from '../../types/single-product-data-type';
import { onClickEventHandlers } from './on-click-event-handlers';

export const productTitle: IDynamicSimpleText = {
  // id: 'square-panel-item-content-product-title', // Does not work ATM as it is not reindexed because it is not the first child in what the array renderer renders.
  contentTypeId: 'dynamic-elements-simple-text',
  inputs: {
    text: {
      values: [
        {
          provider: 'parent',
          property: 'itemData',
        },
        {
          provider: 'id:root',
          property: 'overrideProductTitleFromPropertyKey',
        },
      ],

      transform: function ([{ product }, overrideProductTitleFromPropertyKey]: [
        SingleProductDataType,
        string | undefined | null,
      ]): string {
        let titleToShow = product.articleTitle;
        if (
          overrideProductTitleFromPropertyKey !== undefined &&
          overrideProductTitleFromPropertyKey !== null &&
          Boolean(overrideProductTitleFromPropertyKey) &&
          overrideProductTitleFromPropertyKey in product
        ) {
          const propertyValue = (
            product as unknown as { [key: string]: string }
          )[overrideProductTitleFromPropertyKey];
          if (typeof propertyValue === 'string' && Boolean(propertyValue)) {
            titleToShow = propertyValue;
          }
        }
        return window.neoclesDynamicFramework.recommendationsPanels.methods.decode(
          titleToShow,
        );
      }.toString(),
    },
  },
  styles: {
    classes: ['d-block', 'text-center', 'h4', 'mt-1', 'mb-1', 'text-truncate'],
    variables: {
      '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
    },
    dynamicVariables: { provider: 'id:root', property: 'fontSize' },
  },
  eventHandlers: {
    onClick: onClickEventHandlers,
  },
};
